export default __webpack_public_path__ + "static/media/cpThaiRegisterBanner.4cd380aa.jpg";